/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderAll: {
  name: 'border-all';
  data: string;
} = {
  name: 'border-all',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"/></svg>`
};
